import { ChainId } from '../config/networks';
// Details can be found here: https://github.com/wormhole-foundation/wormhole-sdk-ts/blob/d847b4df3c59fbefba9685676efc31fa088951ff/tokenRegistry/src/tokens/MainnetTokens.json
export const WormholeTokens = [
    {
        name: 'WETH',
        symbol: 'WETH',
        nativeChain: ChainId.ETHEREUM,
        chainTokens: [
            {
                chainId: ChainId.ETHEREUM,
                address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                decimals: 18,
            },
            {
                chainId: ChainId.SOLANA,
                address: '7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs',
                decimals: 8,
            },
            {
                chainId: ChainId.SUI,
                address: '0xaf8cd5edc19c4512f4259f0bee101a40d41ebed738ade5874359610ef8eeced5::coin::COIN',
                decimals: 8,
            },
            {
                chainId: ChainId.OPTIMISM,
                address: '0xb47bC3ed6D70F04fe759b2529c9bc7377889678f',
                decimals: 18,
            },
            {
                chainId: ChainId.BSC,
                address: '0x4DB5a66E937A9F4473fA95b1cAF1d1E1D62E29EA',
                decimals: 18,
            },
            {
                chainId: ChainId.POLYGON,
                address: '0x11CD37bb86F65419713f30673A480EA33c826872',
                decimals: 18,
            },
            {
                chainId: ChainId.AVALANCHE,
                address: '0x8b82A291F83ca07Af22120ABa21632088fC92931',
                decimals: 18,
            },
            {
                chainId: ChainId.BASE,
                address: '0x71b35ECb35104773537f849FBC353F81303A5860',
                decimals: 18,
            },
            {
                chainId: ChainId.ARBITRUM,
                address: '0xD8369C2EDA18dD6518eABb1F85BD60606dEb39Ec',
                decimals: 18,
            },
        ],
    },
    // TODO: test which of the following tokens work fine, and add them to active list
    //   {
    //     name: 'wstETH',
    //     symbol: 'wstETH',
    //     nativeChain: ChainId.ETHEREUM,
    //     chainTokens: [
    //       {
    //         chainId: ChainId.ETHEREUM,
    //         address: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    //         decimals: 18,
    //       },
    //       {
    //         chainId: ChainId.SOLANA,
    //         address: 'ZScHuTtqZukUrtZS43teTKGs2VqkKL8k4QCouR2n6Uo',
    //         decimals: 8,
    //       },
    //     ],
    //   },
    //   {
    //     name: 'tBTC',
    //     symbol: 'tBTC',
    //     nativeChain: ChainId.ETHEREUM,
    //     chainTokens: [
    //       {
    //         chainId: ChainId.ETHEREUM,
    //         address: '0x8dAEBADE922dF735c38C80C7eBD708Af50815fAa',
    //         decimals: 18,
    //       },
    //       {
    //         chainId: ChainId.SOLANA,
    //         address: '25rXTx9zDZcHyTav5sRqM6YBvTGu9pPH9yv83uAEqbgG',
    //         decimals: 8,
    //       },
    //       {
    //         chainId: ChainId.SUI,
    //         address: '0xbc3a676894871284b3ccfb2eec66f428612000e2a6e6d23f592ce8833c27c973::coin::COIN',
    //         decimals: 8,
    //       },
    //     ],
    //   },
    //   {
    //     name: 'WETH',
    //     symbol: 'WETH',
    //     nativeChain: ChainId.ETHEREUM,
    //     chainTokens: [
    //       {
    //         chainId: ChainId.ETHEREUM,
    //         address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
    //         decimals: 18,
    //       },
    //       {
    //         chainId: ChainId.SOLANA,
    //         address: '7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs',
    //         decimals: 8,
    //       },
    //       {
    //         chainId: ChainId.SUI,
    //         address: '0xaf8cd5edc19c4512f4259f0bee101a40d41ebed738ade5874359610ef8eeced5::coin::COIN',
    //         decimals: 8,
    //       },
    //       {
    //         chainId: ChainId.OPTIMISM,
    //         address: '0xb47bC3ed6D70F04fe759b2529c9bc7377889678f',
    //         decimals: 18,
    //       },
    //     ],
    //   },
    //   {
    //     name: 'USDC (Ethereum)',
    //     symbol: 'USDC',
    //     nativeChain: ChainId.ETHEREUM,
    //     chainTokens: [
    //       {
    //         chainId: ChainId.ETHEREUM,
    //         address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
    //         decimals: 6,
    //       },
    //       {
    //         chainId: ChainId.SOLANA,
    //         address: 'A9mUU4qviSctJVPJdBJWkb28deg915LYJKrzQ19ji3FM',
    //         decimals: 6,
    //       },
    //       {
    //         chainId: ChainId.SUI,
    //         address: '0x5d4b302506645c37ff133b98c4b50a5ae14841659738d6d733d59d0d217a93bf::coin::COIN',
    //         decimals: 6,
    //       },
    //       {
    //         chainId: ChainId.OPTIMISM,
    //         address: '0x711e53D031ea9B0bb0C24dD506df11b41AEA419e',
    //         decimals: 6,
    //       },
    //     ],
    //   },
    //   {
    //     name: 'WBTC',
    //     symbol: 'WBTC',
    //     nativeChain: ChainId.ETHEREUM,
    //     chainTokens: [
    //       {
    //         chainId: ChainId.ETHEREUM,
    //         address: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
    //         decimals: 8,
    //       },
    //       {
    //         chainId: ChainId.SOLANA,
    //         address: '3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh',
    //         decimals: 8,
    //       },
    //       {
    //         chainId: ChainId.SUI,
    //         address: '0x27792d9fed7f9844eb4839566001bb6f6cb4804f66aa2da6fe1ee242d896881::coin::COIN',
    //         decimals: 8,
    //       },
    //     ],
    //   },
    //   {
    //     name: 'USDT',
    //     symbol: 'USDT',
    //     nativeChain: ChainId.ETHEREUM,
    //     chainTokens: [
    //       {
    //         chainId: ChainId.ETHEREUM,
    //         address: '0xdac17f958d2ee523a2206206994597c13d831ec7',
    //         decimals: 6,
    //       },
    //       {
    //         chainId: ChainId.SOLANA,
    //         address: 'Dn4noZ5jgGfkntzcQSUZ8czkreiZ1ForXYoV2H8Dm7S1',
    //         decimals: 6,
    //       },
    //       {
    //         chainId: ChainId.SUI,
    //         address: '0xc060006111016b8a020ad5b33834984a437aaa7d3c74c18e09a95d48aceab08c::coin::COIN',
    //         decimals: 6,
    //       },
    //     ],
    //   },
    //   {
    //     name: 'DAI',
    //     symbol: 'DAI',
    //     nativeChain: ChainId.ETHEREUM,
    //     chainTokens: [
    //       {
    //         chainId: ChainId.ETHEREUM,
    //         address: '0x6b175474e89094c44da98b954eedeac495271d0f',
    //         decimals: 18,
    //       },
    //       {
    //         chainId: ChainId.SOLANA,
    //         address: 'EjmyN6qEC1Tf1JxiG1ae7UTJhUxSwk1TCWNWqxWV4J6o',
    //         decimals: 8,
    //       },
    //     ],
    //   },
    //   {
    //     name: 'BUSD',
    //     symbol: 'BUSD',
    //     nativeChain: ChainId.ETHEREUM,
    //     chainTokens: [
    //       {
    //         chainId: ChainId.ETHEREUM,
    //         address: '0x4fabb145d64652a948d72533023f6e7a623c7c53',
    //         decimals: 18,
    //       },
    //       {
    //         chainId: ChainId.SOLANA,
    //         address: '33fsBLA8djQm82RpHmE3SuVrPGtZBWNYExsEUeKX1HXX',
    //         decimals: 8,
    //       },
    //     ],
    //   },
    //   {
    //     name: 'SUI',
    //     symbol: 'SUI',
    //     nativeChain: ChainId.SUI,
    //     chainTokens: [
    //       {
    //         chainId: ChainId.SUI,
    //         address: '0x2::sui::SUI',
    //         decimals: 9,
    //       },
    //       {
    //         chainId: ChainId.ETHEREUM,
    //         address: '0x84074EA631dEc7a4edcD5303d164D5dEa4c653D6',
    //         decimals: 9,
    //       },
    //       {
    //         chainId: ChainId.SOLANA,
    //         address: 'G1vJEgzepqhnVu35BN4jrkv3wVwkujYWFFCxhbEZ1CZr',
    //         decimals: 8,
    //       },
    //     ],
    //   },
    //   {
    //     name: 'WSOL',
    //     symbol: 'WSOL',
    //     nativeChain: ChainId.SOLANA,
    //     chainTokens: [
    //       {
    //         chainId: ChainId.SOLANA,
    //         address: 'So11111111111111111111111111111111111111112',
    //         decimals: 9,
    //       },
    //       {
    //         chainId: ChainId.ETHEREUM,
    //         address: '0xD31a59c85aE9D8edEFeC411D448f90841571b89c',
    //         decimals: 9,
    //       },
    //       {
    //         chainId: ChainId.SUI,
    //         address: '0xb7844e289a8410e50fb3ca48d69eb9cf29e27d223ef90353fe1bd8e27ff8f3f8::coin::COIN',
    //         decimals: 8,
    //       },
    //     ],
    //   },
    //   {
    //     name: 'USDC (Solana)',
    //     symbol: 'USDC',
    //     nativeChain: ChainId.SOLANA,
    //     chainTokens: [
    //       {
    //         chainId: ChainId.SOLANA,
    //         address: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
    //         decimals: 6,
    //       },
    //       {
    //         chainId: ChainId.ETHEREUM,
    //         address: '0x41f7B8b9b897276b7AAE926a9016935280b44E97',
    //         decimals: 6,
    //       },
    //       {
    //         chainId: ChainId.SUI,
    //         address: '0xb231fcda8bbddb31f2ef02e6161444aec64a514e2c89279584ac9806ce9cf037::coin::COIN',
    //         decimals: 6,
    //       },
    //     ],
    //   },
];
